import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { ALERT_BANNERS } from '../../constants/alertBanners';
import { H1 } from '../../components/Text/Text';
import Style from '../../styles/common';

const Container = styled('div')`
  height: ${Style.MEASUREMENT.VIEW.HEADER};
`;

const Content = styled('header')`
  align-items: center;
  background-color: ${Style.color.VIEW_BANNER.BACKGROUND};
  border-bottom: 2px solid ${Style.color.VIEW_BANNER.BOTTOM_BORDER};
  display: flex;
  height: ${Style.MEASUREMENT.VIEW.HEADER};
  justify-content: center;
  position: fixed;
  top: ${Style.MEASUREMENT.MASTHEAD.HEIGHT}px;
  width: 100%;
  z-index: 10;
`;

const Header = styled('div')`
  flex-grow: 1;
  max-width: ${Style.MEASUREMENT.PAGE.MAX_WIDTH};
  padding: 0 ${Style.SPACING.L};
`;

function PageHeader(props) {
  return (
    <Container>
      <Content>
        <Header>
          <H1>{props.children}</H1>
        </Header>
      </Content>
    </Container>
  );
}

PageHeader.propTypes = {
  children: PropTypes.string.isRequired,
  isBannerVisible: PropTypes.bool,
};

PageHeader.defaultProps = {
  isBannerVisible: false,
};

export default connect(
  state => ({
    isBannerVisible: state.alertBanner[ALERT_BANNERS.BETA],
  }),
)(PageHeader);



// WEBPACK FOOTER //
// ./src/components/PageHeader/PageHeader.js